import { AuditActionTypes } from "./types";
import { ActionCreator, Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { ApplicationState } from "../index";
import config from "../../config";

const { api } = config;
const DTS_API_STUDENT = api.DTS_API_STUDENT

export type AppThunk = ActionCreator<ThunkAction<void, ApplicationState, null, Action<string>>>;

export const auditsGetRequest: AppThunk = (data, signal) => {
    let requestbody = data ? data : {}
    return async (dispatch: Dispatch, getState): Promise<void> => {        
        const { auth: { token } } = getState();
        dispatch({
            type: AuditActionTypes.GET_AUDIT_REQUEST
        });  
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (token) {
            headers.append('Authorization', 'Bearer ' + token);
        }
        const response = await fetch(`${DTS_API_STUDENT}/api/audits/get`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(requestbody),
            signal
        }).catch((error) => {
            return false;
        });
        if(typeof response === 'object' && !Array.isArray(response) && response !== null) {
            const body = await response?.json();
            const {response: response_1, body: body_1} = {response, body};
            if (!response_1.ok) {
                dispatch({
                    type: AuditActionTypes.GET_AUDIT_ERROR,
                    payload: body_1
                });
            } else {
                dispatch({
                    type: AuditActionTypes.GET_AUDIT_SUCCESS,
                    payload: body_1
                });
            }
        }
    };
};
export const auditsSummaryGetRequest: AppThunk = (data, signal) => {
    let requestbody = data ? data : {}
    return async (dispatch: Dispatch, getState): Promise<void> => {        
        const { auth: { token } } = getState();
        dispatch({
            type: AuditActionTypes.GET_AUDIT_SUMMARY_REQUEST
        });  
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (token) {
            headers.append('Authorization', 'Bearer ' + token);
        }
        const response = await fetch(`${DTS_API_STUDENT}/api/audits/summary`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(requestbody),
            signal
        }).catch((error) => {
            return false;
        });
        if(typeof response === 'object' && !Array.isArray(response) && response !== null) {
            const body = await response?.json();
            const {response: response_1, body: body_1} = {response, body};
            if (!response_1.ok) {
                dispatch({
                    type: AuditActionTypes.GET_AUDIT_SUMMARY_ERROR,
                    payload: body_1
                });
            } else {
                dispatch({
                    type: AuditActionTypes.GET_AUDIT_SUMMARY_SUCCESS,
                    payload: body_1
                });
            }
        }
    };
};

